export default {"src":"/_next/static/media/VISA.888fb660.svg","height":127,"width":200,"blurWidth":0,"blurHeight":0};